var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "patrol-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-history" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("patrol.titles.listing")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "scroll" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col col-xl-12 mt-3" },
              [
                _c("SuperTable", {
                  ref: "tablePatrols",
                  attrs: {
                    tableColumns: _vm.tableColumns,
                    tableData: _vm.tableData,
                  },
                  on: {
                    sort: _vm.handleSort,
                    filter: _vm.handleFilter,
                    delete: _vm.handleDelete,
                    copy: _vm.handleCopy,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _vm.useDvFlagAccess("beepiz-patrols-can:export")
                ? _c(
                    "Btn",
                    {
                      class: ["default pull-left"],
                      attrs: { disabled: _vm.tableData.length == 0 },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.dlReport($event)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-file-excel-o" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("patrol.btns.printXLS")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }),
        ]),
      ]),
      _vm._v(" "),
      _c("LoadingMini", { ref: "loading" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }